import { fetchFinance, fetchOperation, postProcessorOnboard } from "utils/api";

export const createMerchant = async (params) => {
  return await fetchOperation("/merchant/detail", params);
}

export const addMdrMerchant = async (params) => {
  return await fetchFinance("/action", {
    ...params,
    method: "post",
    action: "addMerchant",
  });
}

export const onboardProcessors = async (params) => {
  return await postProcessorOnboard("/merchants/sqs", {
    ...params,
    onboardType: "PFAAS_ONBOARD",
  });
}